import styled from 'styled-components';

export default styled.div`
  display: flex;
  width: 750px;
  max-width: 100vw;
`;
